import { Address } from '@vex/model/security';
import { Injectable } from '@angular/core';
import { BaseService, IPaginatorService } from './base';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BasePaginator } from '../model/base/base-model';
import { DynamicTemplateFilterViewModel } from '@vex/model/dynamic-template';

@Injectable({
  providedIn: 'root'
})
export class DynamicTemplateService extends IPaginatorService {

  readonly baseEndpoint = 'DynamicTemplate';

  constructor(private http: HttpClient) {
    super();
  }

  getPaginatedData<Address>(sort: string, order: string, page: number, size: number, filter: string, params: number): Observable<BasePaginator<Address>> {

    // let url = this.baseUrl + this.baseEndpoint + '/GetPaginated'
    // let params = {
    //   Filter: filter,
    //   PageNumber: page,
    //   PageSize: size,
    //   Order: order,
    //   Sort: sort,
    //   States: state,
    //   Clouds: cloud,
    //   StartDate: startDate, 
    //   EndDate: endDate
    // }
    let url = this.baseUrl + this.baseEndpoint + '/GetPaginated/' + params + '/' + page + '/' + size + '?';

    if (sort && order) {
      url += `sort=${sort}&order=${order}`;
    }
    if (filter) {
      url += (sort ? '&' : '') + `filter=${filter}`;
    }

    return this.http.get<BasePaginator<Address>>(url);
  }

  getPaginatedPostData(dynamicTemplateFilterViewModel :DynamicTemplateFilterViewModel ) {
    return this.http.post<any>(this.baseUrl + this.baseEndpoint+'/GetPaginatedPost', dynamicTemplateFilterViewModel);
  }

  createDynamicTemplate(template): Observable<any> {
    return this.http.post<any>(this.baseUrl + this.baseEndpoint, template);
  }

  getDynamicTemplates() {
    return this.http.get(this.baseUrl + this.baseEndpoint + '/GetForSelect');
  }

  getDynamicTemplatesByTemplateCreatorId(templateCreatorId) {
    return this.http.get(this.baseUrl + this.baseEndpoint + '/GetForSelectByTemplateCreator/' + templateCreatorId);
  }

  getDynamicTemplatesByTemplateCreatorIds(ids: string[]): Observable<any[]>  {
    return this.http.post<any[]>(this.baseUrl + this.baseEndpoint + '/GetForSelectByTemplateCreatorIds', ids);
  }

  getDynamicTemplateById(id: string) {
    return this.http.get(this.baseUrl + this.baseEndpoint + '/GetById/' + id);
  }

  getDynamicTemplateByIds(ids: string[]): Observable<any[]>  {
    return this.http.post<any[]>(this.baseUrl + this.baseEndpoint + '/GetByIds', ids);
  }

  deleteDynamicTemplate(id: string): Observable<any> {
    return this.http.delete<any>(this.baseUrl + this.baseEndpoint + '/' + id);
  }

  deleteDynamicTemplates(templates: any[]): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + this.baseEndpoint + '/DeleteDynamicTemplates', templates);
  }

  updateDynamicTemplate(template): Observable<any> {
    return this.http.put<any>(this.baseUrl + this.baseEndpoint + '/' + template.Id + '?id=' + template.Id, template);
  }

  parseTemplateConfiguration(id: string): Observable<any> {
    return this.http.post<any>(this.baseUrl + this.baseEndpoint + '/ParseTemplateConfiguration/' + id, {});
  }

  updateloadImage(appCompId: string, file: File) {
    const formData = new FormData();
    formData.append('DynamicTemplateId', appCompId);
    formData.append('file', file, file.name);

    const params = new HttpParams();

    const options = {
      params,
      reportProgress: false,
    };

    return this.http.post<any>(this.baseUrl + this.baseEndpoint + '/UploadDynamicTemplateImage', formData, options);
  }

  getForSelectPaginated(params){
    let url = this.baseUrl + this.baseEndpoint + '/GetForSelectPaginated'
    return this.http.post<any>(url, params);
  }

  checkNameAvailibility(name: string): Observable<string[]> {
    return this.http.get<string[]>(this.baseUrl + this.baseEndpoint + '/CheckName/' + encodeURIComponent(name));
  }

  getForSelectByTypeAndResourceId(type, resourceId) {
    return this.http.get(this.baseUrl + this.baseEndpoint + '/GetForSelectByTypeAndResourceId/' + type +'/' + resourceId);
  }
}
